const City = {

    // FIELDS
    "name": "Name",
    "country": "Country",
    "state": "State",
    "status": "Status",
    "search": "Search",

    // PAGE HEADER
    "city": "City",

    // ERROR
    "error_name": "Enter Name",
    "error_country": "Select Country",
    "error_state": "Select State",
    "error_status": "Select Status",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_state": "STATE",
    "table_country": "COUNTRY",
    "table_status": "STATUS",

}

export default City;